import React from "react";
import { Link } from "react-router-dom";

const AboutYth = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-12 lg:gap-16">
          {/* --- Left Column: Content (Mobile: Bottom, Desktop: Left) --- */}
          <div className="order-2 md:order-1 max-w-2xl mx-auto md:mx-0 text-center md:text-left">
            {/* Main Title */}
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4 tracking-tight">
              Yarqin Tech Hub
            </h2>

            {/* Subtitle - Blue for contrast */}
            <h3 className="text-xl md:text-2xl font-bold text-blue-600 mb-6 leading-tight">
              Accreditation Institution for Technology Companies
            </h3>

            {/* Description */}
            <p className="px-5 text-lg text-slate-600 leading-relaxed mb-8 text-justify md:text-left">
              Yarqin Tech Hub is an innovative institution specializing in
              accreditation and marketing for technology companies. It was
              established with the goal of supporting active organizations in
              the technology sector and building trust between developers and
              customers. Companies that partner with us receive official
              membership and are granted the Yarqin Certification Mark — a
              symbol of trust, quality, and security, comparable to
              international standards such as ISO. This mark represents
              reliability and excellence in software products. When customers
              see it, they can confidently use the services and products of
              member companies knowing they meet verified quality and security
              standards.
            </p>

            {/* CTA Link */}
            <div className="flex flex-col sm:flex-row gap-4 items-center justify-center md:justify-start">
              <Link
                to="/about"
                className="group inline-flex items-center px-6 py-3 text-base font-semibold text-blue-600 transition-all hover:text-blue-800"
              >
                Learn more about us
                <svg
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div>
          </div>

          {/* --- Right Column: Image (Mobile: Top, Desktop: Right) --- */}
          <div className="order-1 md:order-2 group cursor-pointer relative">
            {/* Image Container */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
              <img
                src="https://images.unsplash.com/photo-1531973576160-7125cd663d86"
                alt="Yarqin Tech Hub Team"
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              {/* Overlay Gradient for subtle depth on hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>

            {/* Decorative Element behind image (Optional for visual flair) */}
            <div className="absolute -top-4 -right-4 w-full h-full rounded-2xl border-2 border-blue-600 -z-10 transform translate-x-2 translate-y-2 hidden md:block"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutYth;
